module.exports = __webpack_public_path__ + "img/logo12.1daad5f0.png";